/**
 * Labstep
 *
 * @module prosemirror/components/Menu/File/ActionList
 * @desc List of actions for manipulating a file node
 */

import { FileActionAnnotate } from 'labstep-web/components/File/Action/Annotate';
import { FileActionDownloadContainer as FileActionDownload } from 'labstep-web/components/File/Action/Download';
import { FilePreviewContainer as FilePreview } from 'labstep-web/components/File/Preview';
import { ICONS } from 'labstep-web/constants/icons';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { Button } from 'labstep-web/core/Button';
import { Icon } from 'labstep-web/core/Icon';
import { File } from 'labstep-web/models/file.model';
import type React from 'react';
import type { IMenuFileActionListProps } from './types';

/** Number of pixels to display menu above selection */
export const LINE_HEIGHT = 40;

export const MenuFileActionList: React.FC<
  IMenuFileActionListProps
> = ({
  id,
  additionalActions,
  showAnnotate = true,
  viewInlineAction,
}) => (
  <EntityReadEntityContainer entityName={File.entityName} id={id}>
    {({ entity: file }) => {
      if (!file) {
        return null;
      }
      return (
        <>
          <FileActionDownload
            file={file}
            actionComponentProps={{ type: 'button', showIcon: true }}
          />
          <FilePreview
            noDiv
            file={file}
            viewComponent={({ toggle }) => (
              <Button onClick={toggle}>
                <Icon name={ICONS.file.actions.preview} />
                <span>Preview</span>
              </Button>
            )}
          />
          {file.canAnnotate && showAnnotate && (
            <FileActionAnnotate
              file={file}
              viewComponent={({ toggle }) => (
                <Button onClick={toggle}>
                  <Icon name={ICONS.file.actions.annotate} />
                  <span>Annotate</span>
                </Button>
              )}
            />
          )}
          {file.canViewInline && viewInlineAction}
          {additionalActions}
        </>
      );
    }}
  </EntityReadEntityContainer>
);
